import React, { useState } from "react";
import ClipLoader from 'react-spinners/ClipLoader';
import { addDoc, collection, db } from "../../firebase"; // Ajusta la ruta si es necesario

import { toast } from "react-toastify";

const BusSection = (props) => {

  const [isLoading, setIsLoading] = useState(false);  // Estado para el loader

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    seats: 1,
  });

  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setIsLoading(true);
      // Guardar los datos en Firebase Firestore
      await addDoc(collection(db, "BUS"), {
        name: formData.name || "",
        phone: formData.phone || "",
        seats: formData.seats || null,
        timestamp: new Date(), // Fecha de envío
      });

      // Desplazarse al elemento con id "campo-nombre"
      const elemento = document.getElementById("bus");
      if (elemento) {
        const posicion = elemento.getBoundingClientRect().top + window.scrollY; // Calcula la posición en la página
        window.scrollTo({
          top: posicion - "0", // Aplica el offset restándolo
          behavior: "smooth", // Desplazamiento suave
        });
      }
      setFormSubmitted(true);
    } catch (error) {
      toast.error('Ha habido un error en el envío', {
        position: "top-center", // Posición central superior
        autoClose: 3000, // Tiempo de duración (en milisegundos)
        hideProgressBar: true, // Mostrar barra de progreso
        closeOnClick: true, // Cierre al hacer clic
        pauseOnHover: true, // Pausa al pasar el cursor
        draggable: true, // Permitir arrastrar el toast
        progress: undefined, // Barra de progreso predeterminada
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className={`section-padding`} id="bus">
      {/* Mostrar el loader mientras isLoading sea verdadero */}
      {isLoading && (
        <div className="loader-overlay">
          <ClipLoader color="#fff" loading={isLoading} size={50} />
        </div>
      )}
      <div className="wpo-cta-section wpo-bus-section">
        <div className="conatiner-fluid">
          <div className="wpo-cta-item">
            <h2>Reserva de Autobús</h2>
            <p className="p-0 m-0" style={{ color: 'white' }}>(Si no necesitas autobús, desliza para abajo y sigue descubriendo 😉)</p>
          </div>
        </div>
      </div>
      <div className="container">
        {formSubmitted ? (<div style={{ textAlign: "center", marginTop: "50px" }}>
          <h2>¡Gracias por unirte al autobús! 🚌🌟</h2>
          <br></br>
          <p>Tu plaza está casi confirmada (solo falta que el autobús pase la ITV). Te avisaremos en cuanto tengamos más detalles sobre horarios. </p>
        </div>) :

          (<div className="flex mt-5 px-4">
            <div className="col-12 col-lg-6 mx-auto">

              <h1 className="mb-4">🚌 ¡La boda empieza en el bus! 🎉</h1>
              <p>¿Vienes desde Tarragona? </p>
              <p>
                Estamos organizando un autobús para que llegues sin complicaciones. Necesitamos saber cuántos estaríais interesados para ver si somos suficientes.</p>

              <p>Os mantendremos informados a través de whatsapp de todos los detalles.
                Así, si hay cambios de última hora o se decide llevar karaoke en el bus, serás el primero en enterarte. 😉📲</p>

              <p>Si quieres reservar plaza, déjanos tus datos aquí abajo:</p>

              <h2 className="mt-4">Detalles preliminares del autobús:</h2>
              <p>
                <ul className="mt-4">
                  <li>
                    <strong>Salida:</strong> Viernes 20, por la tarde (hora por confirmar), desde Tarragona.
                  </li>
                  <li>
                    <strong>Regreso:</strong> Domingo 22, al mediodía, desde Jaén.
                  </li>
                </ul>
              </p>

              <form onSubmit={handleSubmit} className="card shadow p-3" style={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                'margin-top': "2rem",
                borderRadius: "10px"
              }}>
                <label>
                  Nombre:
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Tu nombre completo"
                    style={{ width: "100%", padding: "10px", marginTop: "5px" }}
                  />
                </label>

                <label>
                  Teléfono:
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    placeholder="Tu número de teléfono"
                    style={{ width: "100%", padding: "10px", marginTop: "5px" }}
                  />
                </label>

                <label>
                  Número de plazas:
                  <input
                    type="number"
                    name="seats"
                    value={formData.seats}
                    onChange={handleChange}
                    min="1"
                    required
                    style={{ width: "100%", padding: "10px", marginTop: "5px" }}
                  />
                </label>

                <button
                  type="submit"
                  style={{
                    padding: "10px 20px",
                    backgroundColor: "#55aab5",
                    color: "white",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                  }}
                >
                  Enviar
                </button>
              </form>

            </div>
          </div>)}
      </div>
    </section >

  );
};

export default BusSection;
